import { GetAssetResponse } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const GET_ASSET_QUERY_KEY = 'assets.getAsset';

type GetAssetQueryOptions = UseQueryOptions<AxiosResponse<GetAssetResponse>>;

const defaultParameters = { enabled: true };

export const useGetAsset = ({
  assetId,
  assetTenantId,
  enabled,
  refetchInterval,
}: {
  assetId?: string;
  assetTenantId?: string;
  enabled?: boolean;
  refetchInterval?: GetAssetQueryOptions['refetchInterval'];
} = defaultParameters) => {
  const { getTenantId } = useTenants();
  const tenantId = assetTenantId ?? getTenantId();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [GET_ASSET_QUERY_KEY, { assetId, tenantId }],
    queryFn: () => api.assets.getAsset(tenantId, assetId ?? ''),
    enabled: !!assetId && !!tenantId && enabled,
    refetchInterval,
  });

  return {
    asset: data?.data.asset,
    isLoading,
    error,
    refetch,
  };
};
